module.exports = __webpack_public_path__ + "media/images/email_2-b01ce3812413a418afefe86f860744a7.jpg";